/**
 * API calls both products use.
 *
 * Deliberately small — five calls behind shared UI (the search bar's
 * notifications, bank and branch lookups, operational signature upload).
 * Anything that can be attributed to one product belongs in claims.ts or
 * ifas.ts instead; this module is not a dumping ground.
 */

import instance from "./api";
import EndPoints from "./api-endpoints";

export const getBranchName = async () => {
  try {
    return instance
      .get(EndPoints.getBranchName)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

export const getAllBanks = async () => {
  try {
    return instance
      .get(EndPoints.getAllBanks)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

export const getNotifications = async ({
  recipientUserId,
  recipientEmail,
  unreadOnly = false,
  size = 20,
}: {
  recipientUserId?: string;
  recipientEmail?: string;
  unreadOnly?: boolean;
  size?: number;
}) => {
  try {
    return instance
      .get(EndPoints.getNotifications, {
        params: {
          ...(recipientUserId ? { recipientUserId } : {}),
          ...(recipientEmail ? { recipientEmail } : {}),
          unreadOnly,
          size,
        },
      })
      .then((response) => response)
      .catch((error) => error.response);
  } catch (error) {
    return error;
  }
};

export const markNotificationAsRead = async (
  notificationId: string,
  {
    recipientUserId,
    recipientEmail,
  }: {
    recipientUserId?: string;
    recipientEmail?: string;
  }
) => {
  try {
    return instance
      .post(`${EndPoints.markNotificationRead}/${notificationId}/read`, null, {
        params: {
          ...(recipientUserId ? { recipientUserId } : {}),
          ...(recipientEmail ? { recipientEmail } : {}),
        },
      })
      .then((response) => response)
      .catch((error) => error.response);
  } catch (error) {
    return error;
  }
};

export const uploadOperationalSignature = async (
  module: string,
  referenceNumber: string,
  fieldName: string,
  file: File,
) => {
  try {
    const formData = new FormData();
    formData.append("module", module);
    formData.append("referenceNumber", referenceNumber);
    formData.append("fieldName", fieldName);
    formData.append("file", file);

    return instance
      .post(EndPoints.uploadOperationalSignature, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*/*",
        },
      })
      .then((response) => response)
      .catch((error) => error.response);
  } catch (error) {
    return error;
  }
};
